import React from 'react';
import classNames from 'classnames';
import { compose, render } from '@/utils/story-composer';
import { getTailwindClassByEnum } from '@/utils/cssHelpers';
import { BackgroundColorEnum } from '@/enums/styling';

function TableRow({ columns, backgroundColor, border, borderSize, borderColor }) {
	const backgroundClass = getTailwindClassByEnum(BackgroundColorEnum, backgroundColor);

	return <tr className={classNames(backgroundClass)}>{render(columns, { border, borderSize, borderColor })}</tr>;
}

export default TableRow;

compose('table-row', TableRow, { children: ['table-column'] });
